import { Link } from 'react-router-dom'
import { SettingsRoutePath } from '$features/settings/routes/protected'
import { Router } from '$utils/router'
import { Text } from '$components'

type PetOptionSettingsLinkProps = {
  type: 'size' | 'coat'
}

export function PetOptionSettingsLink({ type }: PetOptionSettingsLinkProps) {
  const path = type === 'size'
    ? Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsPetOptionsSizes)
    : Router.buildRoute(SettingsRoutePath.Settings, SettingsRoutePath.SettingsPetOptionsCoats)

  const topic = type === 'size'
    ? 'size categories and weight bands'
    : 'coat types'

  return (
    <Text
      type="xs"
      className="mt-stack-dense leading-relaxed"
    >
      You can add new options or edit{' '}
      {topic}
      {' '}
      in{' '}
      <Link
        to={path}
        className="font-medium text-fg-muted underline underline-offset-2 decoration-fg-disabled hover:text-fg hover:decoration-fg-subtle"
      >
        settings
      </Link>
      .
    </Text>
  )
}
